// extracted by mini-css-extract-plugin
export default {"card":"general-discount-price_card__t0tzA"};